import { render, staticRenderFns } from "./stateBuyGoodsDialog.vue?vue&type=template&id=612fc048&"
import script from "./stateBuyGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./stateBuyGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports